<template>
  <div class="textarea-wrapper">
    <div class="textarea-group">
            <textarea
                :id="id"
                :placeholder="placeholder"
                :type="type"
                :value="value"
                @keyup="inputChanged"
                class="textarea-field font-size-middle"
                rows="19"
                style="resize: none; cursor: auto"
            />
      <label :for="id" class="textarea-label font-size-middle">{{ placeholder }}</label>
    </div>
  </div>
</template>

<script>
import { uniqueId } from 'lodash'

export default {
  name: 'TextArea',
  mounted () {
    this.id = uniqueId('textarea-group-')
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      id: null,
    }
  },
  methods: {
    inputChanged (event) {
      this.$emit('input', event.target.value)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $grey-light;
  border: thin solid $grey-light;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $dark-text;
  border: thin solid $dark-text;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $primary;
  border: thin solid $primary;
  border-radius: 10px;
}

.textarea-wrapper {

  .textarea-group > textarea:focus,
  .textarea-group > textarea:not(:placeholder-shown) {
    border-bottom: 2px solid $primary;
  }

  .textarea-group > textarea:focus + label,
  .textarea-group > textarea:not(:placeholder-shown) + label {
    top: 0;
    left: 0;
    font-size: 14px;
    color: $primary;
  }

  .textarea-group {
    position: relative;
    padding: 15px 0 0;
    margin-top: 10px;
  }

  .textarea-field {
    font-family: inherit;
    width: 100%;
    border: 0;
    border-bottom: 1px solid $grey-light;
    outline: 0;
    color: $grey-light;
    padding: 7px 0;
    background: transparent;
    transition: border-color 0.2s;
  }

  .textarea-field::placeholder {
    color: transparent;
  }

  .textarea-field:placeholder-shown ~ .textarea-label {
    cursor: text;
    top: 25px;
    left: 9px;
  }

  label,
  .textarea-field:focus ~ .textarea-label {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    transition: all 0.2s ease-in-out;
    color: $grey-light;
  }

  .textarea-field:focus ~ .textarea-label {
    color: $primary;
  }

  .textarea-field:focus {
    padding-bottom: 6px;
    border-bottom: 2px solid $primary;
  }
}
</style>
